import { useCallback, useState } from 'react';
import axios from 'Axios';
import { toastify, api, clx } from 'Utils';
import { ModalBox, Button, FieldMessage } from 'Elements';
import styles from 'partials/modalbox/modal-form.module.scss';

export const ModalBoxPassword = ({ isOpen, size, onClose, onToggleLogin }) => {
	const initialState = () => ({
		fields: {
			password: '',
			password_confirmation: ''
		},
		isSubmiting: false,
		errors: {}
	});

	const [state, setState] = useState(initialState());

	const resetState = useCallback(() => {
		setState(initialState());
	}, []);

	const handleInput = (e) => {
		const fields = state.fields;
		const target = e.target;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const validateForm = () => {
		let errors = {};
		const fields = state.fields;
		let formIsValid = true;
		if (!fields.password) {
			formIsValid = false;
			errors['password'] = 'کلمه عبور را وارد کنید';
		}
		if (!fields.password_confirmation) {
			formIsValid = false;
			errors['password_confirmation'] = 'تکرار کلمه عبور را وارد کنید';
		}
		if (fields.password !== fields.password_confirmation) {
			formIsValid = false;
			errors['password_confirmation'] = 'تکرار کلمه عبور مطابقت ندارد';
		}

		setState((prev) => ({
			...prev,
			errors
		}));
		return formIsValid;
	};

	const submitForm = () => {
		const mobile = sessionStorage.getItem('mobile');
		const data = {
			...state.fields,
			...{
				mobile
			}
		};
		if (validateForm()) {
			setState((prev) => ({
				...prev,
				isSubmiting: true
			}));
			axios.post(api.forgetPassword, data).then((res) => {
				setState((prev) => ({
					...prev,
					isSubmiting: false
				}));
				const data = res.data;
				if (data.code === 200) {
					if (data.success) {
						// onClose();
						onToggleLogin()
					} else {
						toastify(data.message);
					}
				} else {
					toastify('خطا در برقراری ارتباط با سرور');
				}
			});
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		submitForm();
	};

	return (
		<ModalBox
			isOpen={isOpen}
			size={size}
			onClose={onClose}
			onDestroy={resetState}>
			<header className={styles.header}>
				<h3 className={styles.headerTitle}>ثبت کلمه عبور جدید</h3>
			</header>
			<div className={styles.body}>
				<form className={styles.form} onSubmit={handleSubmit}>
					<div className={styles.fieldset}>
						<label htmlFor="password" className={styles.label}>
							کلمه عبور جدید
						</label>
						<input
							id="password"
							name="password"
							type="password"
							className={[styles.input, styles.input_ltr].join(
								' '
							)}
							onChange={handleInput}
						/>
						{state.errors.password && (
							<FieldMessage text={state.errors.password} />
						)}
					</div>
					<div className={styles.fieldset}>
						<label htmlFor="password" className={styles.label}>
							تکرار کلمه عبور
						</label>
						<input
							id="password_confirmation"
							name="password_confirmation"
							type="password"
							className={[styles.input, styles.input_ltr].join(
								' '
							)}
							onChange={handleInput}
						/>
						{state.errors.password_confirmation && (
							<FieldMessage
								text={state.errors.password_confirmation}
							/>
						)}
					</div>
					<div className={styles.fieldset}>
						<Button
							className={clx(styles.submit, styles.submitFull)}
							disabled={state.isSubmiting}
							type="submit">
							ثبت کلمه عبور جدید
						</Button>
					</div>
				</form>
			</div>
		</ModalBox>
	);
};
